import React, { PureComponent, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Card, CardBody } from 'reactstrap';
import classnames from 'classnames';
import ReactTable from 'react-table';
import moment from 'moment';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import DataTablePagination from 'Components/DataTables/pagination';
import {
	messagesFindAllByPageAndOptions,
	errorReset,
} from 'Redux/actions';
import * as messagesReducer from 'Redux/messages/reducer';
import IntlMessages from 'Util/IntlMessages';

class PageMessages extends PureComponent {
	constructor() {
		super();
		this.state = {
			keyword: '',
			tableState: {},
		};
		this.breadcrumb = [
			{ id: 'menu.message', href: '/message/list' },
		];
		this.columns = [
			{
				id: 'name',
				Header: 'Title',
				accessor: (d) => (
					<NavLink to={ `/app/message/edit/${d.id}` }>
						{ d.name }
					</NavLink>
				),
			},
			{
				Header: 'Content',
				accessor: 'content',
			},
			{
				id: 'period_start',
				Header: 'Period',
				accessor: (d) => (
					<Fragment>
						{ d.period_start ? moment(d.period_start).format('YYYY-MM-DD HH:mm:ss') : '' } -<br />
						{ d.period_end ? moment(d.period_end).format('YYYY-MM-DD HH:mm:ss') : '' }
					</Fragment>
				),
			},
			{
				Header: 'Level',
				accessor: 'level',
			},
			{
				id: 'updated_on',
				Header: 'Last Modified',
				accessor: (d) => (
					d.updated_on ? moment(d.updated_on).format('YYYY-MM-DD HH:mm:ss') : ''
				),
			},
			{
				id: 'status',
				Header: 'Status',
				width: 100,
				accessor: (d) => {
					if (d.status) {
						let className = 'badge-primary';
						switch (d.status.label) {
						case 'Inactive':
							className = 'badge-light';
							break;
						}
						return (
							<span className={ classnames('badge', 'badge-pill', 'text-uppercase', className) }>{ d.status ? d.status.label : '' }</span>
						);
					}
					return '';
				},
			},
			{
				id: 'action',
				Header: '',
				width: 50,
				accessor: (d) => (
					<NavLink className="btn btn-xs btn-outline-primary" to={ `/app/message/edit/${d.id}` }>
						<i className="simple-icon-pencil" />
					</NavLink>
				)
			},
		];
		this.fetchData = this.fetchData.bind(this);
		this.onChangeKeywordHandler = this.onChangeKeywordHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
	}

	componentDidMount() {
		this.props.errorReset('messages');
	}

	fetchData(state) {
		const { keyword } = this.state;
		let params = {
			page: state.page + 1,
			size: state.pageSize,
		};
		if (state.sorted.length > 0) {
			params.sort_column = state.sorted[0].id;
			params.sort_direction = state.sorted[0].desc ? 'desc' : 'asc';
		}
		if (keyword) {
			params.keyword = keyword;
		}
		this.setState({
			tableState: state,
		});
		this.props.messagesFindAllByPageAndOptions(params);
	}

	onChangeKeywordHandler(e) {
		this.setState({
			keyword: e.target.value,
		}, this.onSubmitHandler);
	}

	onSubmitHandler(e) {
		e && e.preventDefault();
		const { tableState } = this.state;
		this.fetchData(tableState);
	}

	render() {
		const { messagesByPage } = this.props;
		const { keyword } = this.state;
		const status = this.props.status.get('messages');
		const isLoading = status === 'fetching';
		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<div className="float-left">
							<BreadcrumbContainer
								heading={ <IntlMessages id="messages.heading" /> }
								items={ this.breadcrumb }
								match={ this.props.match }
							/>
						</div>
						<div className="float-right">
							<NavLink to="/app/message/create" className="btn btn-lg btn-primary">
								CREATE NEW
							</NavLink>
						</div>
						<div className="clearfix"></div>

						<form className="mb-3" onSubmit={ this.onSubmitHandler }>
							<div className="search-sm d-inline-block mr-1 mb-1 align-top">
								<input
									type="text"
									placeholder="Search"
									value={ keyword }
									onChange={ this.onChangeKeywordHandler }
								/>
							</div>
						</form>
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<Row>
					<Colxx xxs="12">
						<Card>
							<CardBody>
								<ReactTable
									manual
									data={ messagesByPage.get('data') }
									pages={ messagesByPage.get('max_page') }
									loading={ isLoading }
									onFetchData={ this.fetchData }
									columns={ this.columns }
									minRows={ 0 }
									showPageJump={ true }
									showPageSizeOptions={ true }
									PaginationComponent={ DataTablePagination }
								/>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

export default connect(
	messagesReducer.selector,
	{
		messagesFindAllByPageAndOptions,
		errorReset,
	}
)(PageMessages);